import { isBookedAhead } from "./helpers";

/*
 * What happened to this car, from the stamps the session already carries. Every
 * runner tap writes one, so the ladder reads back as a history without a
 * separate event log behind it.
 */
const ENTRIES = [
  { at: "arrivedAt", label: "Arrived" },
  { at: "claimedAt", label: "Keys accepted" },
  { at: "parkedAt", label: "Parked", by: "parkedByName" },
  { at: "pickupRequestedAt", label: "Pickup requested" },
  { at: "requestedAt", label: "Pickup booked for", when: isBookedAhead },
  { at: "returningAt", label: "Runner accepted", by: "pickedByName" },
  { at: "enRouteAt", label: "Keys taken" },
  { at: "locatedAt", label: "Car collected" },
  { at: "enRouteToGuestAt", label: "En route to guest" },
  { at: "readyAt", label: "Ready at porte-cochere" },
  { at: "returnedAt", label: "Handed to guest" },
];

export default function sessionHistory(row) {
  if (!row) return [];

  return ENTRIES.filter(
    (entry) => row[entry.at] && (!entry.when || entry.when(row)),
  )
    .map((entry) => ({
      key: entry.at,
      at: row[entry.at],
      label: entry.label,
      by: entry.by ? row[entry.by] ?? null : null,
    }))
    .sort((a, b) => new Date(a.at) - new Date(b.at));
}
